import { useTranslation } from "react-i18next";

import { CallToAction } from "../components/marketing-layout/CallToAction";
import { Team } from "../components/marketing-layout/Team";
import { MarketingLayout } from "../components/marketing-layout";
import { InlineContactSection } from "../components/marketing-layout/InlineContactSection";


export const MarketingAboutUs = () => {
	const { t } = useTranslation();

	return (
        <MarketingLayout>
			<>
				<CallToAction
					headingTitle={t("aboutUs.ctaTitle")}
					headingDescription={t("aboutUs.ctaDescription")}
					leftButtonLink="/contact-us"
					leftButtonText={t("aboutUs.ctaLeftButton") || "Contact Us"}
					ctaImageUrl="about-us-hero-field.jpg"
					ctaImageAlt={t("aboutUs.ctaImageAlt") || "Get Started Image"}
				/>
				<Team />
				<InlineContactSection />
			</>
		</MarketingLayout>
	);
};
